import { apiInstance } from "@/utils/ApiUtil.js";
const API_URL = "/admin/task";

const createTask = async (taskData) => {
    try {
        const response = await apiInstance.post(`${API_URL}/create`, taskData);
        return response.data;
    } catch (error) {
        return false;
    }
};

const deleteTask = async (taskId) => {
    try {
        const response = await apiInstance.delete(`${API_URL}/delete`, {
            data: { taskId },
        });
        return response.data;
    } catch (error) {
        return false;
    }
};

const getAll = async () => {
    try {
        const response = await apiInstance.get(`${API_URL}/all`);
        return response.data;
    } catch (error) {
        return false;
    }
};

const AdminTaskService = {
    getAll,
    createTask,
    deleteTask,
};

export default AdminTaskService;
